export default function isTempUser (user) {
    return user?._id === 'temp-dummy'
}